export default "__VITE_ASSET__BiVhblnI__"